<template>
  <div :class="['page-footer-component-container', { mastery: isMasteryApp }]">
    <slot />
  </div>
</template>

<script>
export default {
  computed: {
    isMasteryApp() {
      return this.$store.getters['app/isMasteryApp'];
    },
  },
};
</script>
<style lang='scss' scoped>
.page-footer-component-container {
  align-items: center;
  background: $white-1;
  border-top: 1px solid rgba(0,0,0,.12);
  bottom: 0;
  display: flex;
  height: rem-calc(64);
  left: rem-calc(220);
  padding: 0 rem-calc(48);
  position: fixed;
  right: 0;

  @include breakpoint(small) {
    left: 0;
    padding: 0 rem-calc(16);
  }

  &.mastery {
    left: rem-calc(88);
    @include breakpoint(small) {
      bottom: rem-calc(72);
      left: 0;
    }
  }
}
</style>
